import ComponentShare from "./ComponentShare";
import InitApp from "./InitApp";
import { store } from "@/stores/dataStore/reduxStore/store";
import AppStyle from '@/App.css';
import classNames from 'classnames/bind';
import SyncDataMF2Host from "./SyncDataMF2Host";
import useIsMobile from "./hooks/useIsMobile";

const cx = classNames.bind(AppStyle);
const ComponentShareWrapper = (props: any) => {
    const { componentName } = props;
    const matches = useIsMobile();


    console.log('remoteApp_log::ComponentShareWrapper', props);
    console.log('remoteApp_log::STORE', store.getState());

    if (componentName === "ComponentApp") {
        return (componentName === "ComponentApp") && <SyncDataMF2Host {...props} />
    } else {
        return (
            <div className={componentName === 'initApp' ? cx('body-content-mini-app hidden') : matches ? cx('body-content-mini-app', 'mobile') : cx('body-content-mini-app')}>
                {componentName === "initApp" && <InitApp {...props} />}
                {componentName !== "initApp" && componentName !== "ComponentApp" && <ComponentShare {...props} />}
            </div>
        )
    }
};

export default ComponentShareWrapper;
